/* ==========================================================
THE VINESCAPE
SALE V2
Monaco Inspired Slider & Quick View Modal
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".vs-sale-v2").forEach((section) => {
        const slider = section.querySelector(".vs-sale-slider");
        if (!slider) return;

        const prev = section.querySelector(".vs-sale-prev");
        const next = section.querySelector(".vs-sale-next");

        const getCardWidth = () => {
            const card = slider.querySelector(".vs-product-card");
            if (!card) return 400;
            const gap = 4;
            return card.offsetWidth + gap;
        };

        /* ------------------------------
           Arrow Navigation
        ------------------------------ */
        const updateNavigation = () => {
            const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
            const hasOverflow = maxScrollLeft > 1;

            if (prev) prev.disabled = !hasOverflow || slider.scrollLeft <= 1;
            if (next) next.disabled = !hasOverflow || slider.scrollLeft >= maxScrollLeft - 1;
        };

        next?.addEventListener("click", () => {
            slider.scrollBy({
                left: getCardWidth(),
                behavior: "smooth"
            });
        });

        prev?.addEventListener("click", () => {
            slider.scrollBy({
                left: -getCardWidth(),
                behavior: "smooth"
            });
        });

        slider.addEventListener("scroll", updateNavigation, { passive: true });
        window.addEventListener("resize", updateNavigation);
        updateNavigation();
    });

    /* ==========================================================
       DYNAMIC QUICK VIEW MODAL
    ========================================================== */
    const qvBtns = document.querySelectorAll(".vs-quickview-btn");
    const overlay = document.getElementById("vsQvOverlay");
    const modal = document.getElementById("vsQvModal");
    const body = document.getElementById("vsQvBody");
    const closeBtn = document.getElementById("vsQvClose");

    const closeQv = () => {
        overlay?.classList.remove("active");
        modal?.classList.remove("active");
        document.body.style.overflow = ""; // restore scroll
    };

    overlay?.addEventListener("click", closeQv);
    closeBtn?.addEventListener("click", closeQv);

    qvBtns.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const handle = btn.getAttribute("data-handle");
            if (!handle) return;

            // Show modal and loading state
            overlay?.classList.add("active");
            modal?.classList.add("active");
            document.body.style.overflow = "hidden"; // lock background scroll

            if (body) {
                body.innerHTML = `<div class="vs-qv-loading"><span>LOADING PRODUCT DETAILS...</span></div>`;
            }

            // Fetch product via AJAX API
            fetch(`/products/${handle}.js`)
                .then(res => {
                    if (!res.ok) throw new Error("Product fetch failed");
                    return res.json();
                })
                .then(product => {
                    renderQuickView(product);
                })
                .catch(err => {
                    console.error(err);
                    if (body) {
                        body.innerHTML = `<div class="vs-qv-error">Failed to load product. Please try again.</div>`;
                    }
                });
        });
    });

    const renderQuickView = (product) => {
        if (!body) return;

        const title = product.title;
        const price = Math.round(product.price / 100).toLocaleString('en-IN');
        const compareAtPrice = product.compare_at_price ? Math.round(product.compare_at_price / 100).toLocaleString('en-IN') : null;
        
        let currencySymbol = "Rs. ";
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
            if (window.Shopify.currency.active === "INR") {
                currencySymbol = "Rs. ";
            } else if (window.Shopify.currency.active === "USD") {
                currencySymbol = "$";
            } else {
                currencySymbol = window.Shopify.currency.active + " ";
            }
        }

        // Discount percent calculation
        let discountHtml = "";
        if (product.compare_at_price > product.price) {
            const pct = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
            discountHtml = `<span class="vs-qv-discount-badge">-${pct}%</span>`;
        }

        // Thumbnails grid
        const thumbnailsHtml = product.images.map((img, i) => {
            return `
                <div class="vs-qv-thumb-item ${i === 0 ? 'active' : ''}" data-src="${img}">
                    <img src="${img}" alt="${title}">
                </div>
            `;
        }).join("");

        // Product options templates (Skip Title / Default Title variant options)
        let optionsHtml = "";
        product.options.forEach((opt, optIndex) => {
            const optNameLower = opt.name.toLowerCase();
            
            // Skip Shopify standard Title/Default option combinations
            if (optNameLower === "title" && opt.values.includes("Default Title")) {
                return;
            }

            if (optNameLower === "color" || optNameLower === "colour") {
                const swatches = opt.values.map((val, valIndex) => {
                    return `
                        <span 
                            class="vs-qv-swatch ${valIndex === 0 ? 'active' : ''}" 
                            style="background-color: ${val.toLowerCase()};" 
                            data-value="${val}" 
                            data-option-index="${optIndex}"
                            title="${val}">
                        </span>
                    `;
                }).join("");
                optionsHtml += `
                    <div class="vs-qv-option-group">
                        <span class="vs-qv-option-label">Color: <strong class="vs-qv-selected-color">${opt.values[0]}</strong></span>
                        <div class="vs-qv-swatches-grid">${swatches}</div>
                    </div>
                `;
            } else if (optNameLower === "size") {
                const sizes = opt.values.map((val, valIndex) => {
                    return `
                        <span 
                            class="vs-qv-size-btn ${valIndex === 0 ? 'active' : ''}" 
                            data-value="${val}" 
                            data-option-index="${optIndex}">
                            ${val}
                        </span>
                    `;
                }).join("");
                optionsHtml += `
                    <div class="vs-qv-option-group">
                        <span class="vs-qv-option-label">Size</span>
                        <div class="vs-qv-sizes-grid">${sizes}</div>
                    </div>
                `;
            } else {
                // Default dropdowns for other options
                const dropdownOptions = opt.values.map((val) => {
                    return `<option value="${val}">${val}</option>`;
                }).join("");
                optionsHtml += `
                    <div class="vs-qv-option-group">
                        <span class="vs-qv-option-label">${opt.name}</span>
                        <select class="vs-qv-option-select" data-option-index="${optIndex}">
                            ${dropdownOptions}
                        </select>
                    </div>
                `;
            }
        });

        // Strip HTML description helper
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = product.description;
        const plainDesc = tempDiv.textContent || tempDiv.innerText || "";
        const descTruncated = plainDesc.substring(0, 160) + (plainDesc.length > 160 ? "..." : "");

        body.innerHTML = `
            <div class="vs-qv-left">
                <div class="vs-qv-main-image-wrap">
                    <img src="${product.featured_image}" id="vsQvMainImage" alt="${title}">
                </div>
                <div class="vs-qv-thumbnails-grid">
                    ${thumbnailsHtml}
                </div>
            </div>
            <div class="vs-qv-right">
                <div class="vs-qv-title-row">
                    <h2 class="vs-qv-title">${title}</h2>
                    <button type="button" class="vs-qv-share-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="vs-qv-share-icon"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
                        <span>Share</span>
                    </button>
                </div>
                
                <div class="vs-qv-price-row">
                    <span class="vs-qv-price">${currencySymbol}${price}</span>
                    ${compareAtPrice ? `<span class="vs-qv-compare">${currencySymbol}${compareAtPrice}</span>` : ""}
                    ${discountHtml}
                </div>
                
                <p class="vs-qv-description">${descTruncated}</p>
                
                <div class="vs-qv-stock">✓ 2 IN STOCK</div>
                
                <div class="vs-qv-options-container">
                    ${optionsHtml}
                </div>
                
                <div class="vs-qv-actions">
                    <div class="vs-qv-qty-selector">
                        <button type="button" class="vs-qv-qty-adjust minus">-</button>
                        <input type="number" class="vs-qv-qty-input" value="1" min="1">
                        <button type="button" class="vs-qv-qty-adjust plus">+</button>
                    </div>
                    <button type="button" class="vs-qv-add-to-cart-btn" id="vsQvAddToCart">ADD TO CART</button>
                </div>
                
                <button type="button" class="vs-qv-buy-now-btn" id="vsQvBuyNow">BUY IT NOW</button>
                
                <div class="vs-qv-details-link-wrap">
                    <a href="${product.url}" class="vs-qv-view-details-link">VIEW DETAILS</a>
                </div>
            </div>
        `;

        // Variant selection logic
        const variants = product.variants;
        let selectedOptions = product.options.map(opt => opt.values[0]);

        const getSelectedVariant = () => {
            return variants.find(v => {
                let match = true;
                if (v.option1 !== null && selectedOptions[0] !== undefined) match = match && (v.option1 === selectedOptions[0]);
                if (v.option2 !== null && selectedOptions[1] !== undefined) match = match && (v.option2 === selectedOptions[1]);
                if (v.option3 !== null && selectedOptions[2] !== undefined) match = match && (v.option3 === selectedOptions[2]);
                return match;
            }) || variants[0];
        };

        const updateVariantStatus = () => {
            const variant = getSelectedVariant();
            if (!variant) return;

            // Update Price display
            const priceEl = body.querySelector(".vs-qv-price");
            const compareEl = body.querySelector(".vs-qv-compare");
            const formattedPrice = Math.round(variant.price / 100).toLocaleString('en-IN');
            if (priceEl) priceEl.innerText = `${currencySymbol}${formattedPrice}`;

            if (compareEl) {
                if (variant.compare_at_price) {
                    const formattedCompare = Math.round(variant.compare_at_price / 100).toLocaleString('en-IN');
                    compareEl.innerText = `${currencySymbol}${formattedCompare}`;
                    compareEl.style.display = "inline";
                } else {
                    compareEl.style.display = "none";
                }
            }

            // Update Stock message and button state
            const stockEl = body.querySelector(".vs-qv-stock");
            const addToCartBtn = body.querySelector("#vsQvAddToCart");
            const buyNowBtn = body.querySelector("#vsQvBuyNow");

            if (stockEl) {
                if (variant.available) {
                    stockEl.innerText = "✓ IN STOCK";
                    stockEl.style.color = "#111111";
                    if (addToCartBtn) {
                        addToCartBtn.disabled = false;
                        addToCartBtn.innerText = "ADD TO CART";
                    }
                    if (buyNowBtn) {
                        buyNowBtn.disabled = false;
                        buyNowBtn.innerText = "BUY IT NOW";
                    }
                } else {
                    stockEl.innerText = "✕ OUT OF STOCK";
                    stockEl.style.color = "#E22D28";
                    if (addToCartBtn) {
                        addToCartBtn.disabled = true;
                        addToCartBtn.innerText = "SOLD OUT";
                    }
                    if (buyNowBtn) {
                        buyNowBtn.disabled = true;
                        buyNowBtn.innerText = "SOLD OUT";
                    }
                }
            }

            // Update main image if variant has featured image
            const mainImage = body.querySelector("#vsQvMainImage");
            if (mainImage && variant.featured_image) {
                mainImage.src = variant.featured_image.src;
                // Also highlight matching thumbnail
                const thumbs = body.querySelectorAll(".vs-qv-thumb-item");
                thumbs.forEach(t => {
                    t.classList.remove("active");
                    if (t.getAttribute("data-src") === variant.featured_image.src) {
                        t.classList.add("active");
                    }
                });
            }
        };

        // Initialize status
        updateVariantStatus();

        // Thumbnails switcher
        const thumbs = body.querySelectorAll(".vs-qv-thumb-item");
        thumbs.forEach(thumb => {
            thumb.addEventListener("click", () => {
                thumbs.forEach(t => t.classList.remove("active"));
                thumb.classList.add("active");
                const newSrc = thumb.getAttribute("data-src");
                if (mainImage && newSrc) {
                    mainImage.src = newSrc;
                }
            });
        });

        // Color Swatches interaction
        const colorSwatches = body.querySelectorAll(".vs-qv-swatch");
        const selectedColorText = body.querySelector(".vs-qv-selected-color");
        colorSwatches.forEach(swatch => {
            swatch.addEventListener("click", () => {
                colorSwatches.forEach(s => s.classList.remove("active"));
                swatch.classList.add("active");
                const val = swatch.getAttribute("data-value");
                const idx = parseInt(swatch.getAttribute("data-option-index"));
                selectedOptions[idx] = val;
                if (selectedColorText) selectedColorText.innerText = val;
                updateVariantStatus();
            });
        });

        // Size button selection
        const sizeBtns = body.querySelectorAll(".vs-qv-size-btn");
        sizeBtns.forEach(btn => {
            btn.addEventListener("click", () => {
                sizeBtns.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");
                const val = btn.getAttribute("data-value");
                const idx = parseInt(btn.getAttribute("data-option-index"));
                selectedOptions[idx] = val;
                updateVariantStatus();
            });
        });

        // Dropdown options
        const selects = body.querySelectorAll(".vs-qv-option-select");
        selects.forEach(select => {
            select.addEventListener("change", () => {
                const idx = parseInt(select.getAttribute("data-option-index"));
                selectedOptions[idx] = select.value;
                updateVariantStatus();
            });
        });

        // Share button functionality (Web Share API)
        const shareBtn = body.querySelector(".vs-qv-share-btn");
        shareBtn?.addEventListener("click", () => {
            if (navigator.share) {
                navigator.share({
                    title: title,
                    url: window.location.origin + product.url
                }).catch(console.error);
            } else {
                // Fallback: Copy to clipboard
                const dummy = document.createElement("input");
                document.body.appendChild(dummy);
                dummy.value = window.location.origin + product.url;
                dummy.select();
                document.execCommand("copy");
                document.body.removeChild(dummy);
                
                const shareText = shareBtn.querySelector("span");
                if (shareText) {
                    shareText.innerText = "COPIED!";
                    setTimeout(() => {
                        shareText.innerText = "Share";
                    }, 2000);
                }
            }
        });

        // Quantity selector increment / decrement
        const qtyInput = body.querySelector(".vs-qv-qty-input");
        const btnMinus = body.querySelector(".vs-qv-qty-adjust.minus");
        const btnPlus = body.querySelector(".vs-qv-qty-adjust.plus");

        btnMinus?.addEventListener("click", () => {
            let current = parseInt(qtyInput.value) || 1;
            if (current > 1) qtyInput.value = current - 1;
        });

        btnPlus?.addEventListener("click", () => {
            let current = parseInt(qtyInput.value) || 1;
            qtyInput.value = current + 1;
        });

        // Add to Cart listener
        const addToCartBtn = body.querySelector("#vsQvAddToCart");
        addToCartBtn?.addEventListener("click", () => {
            const variant = getSelectedVariant();
            const quantity = parseInt(qtyInput.value) || 1;

            if (addToCartBtn) {
                addToCartBtn.innerText = "ADDING...";
                addToCartBtn.disabled = true;
            }

            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: variant.id, quantity: quantity })
            })
            .then(res => {
                if (!res.ok) throw new Error("Add to cart failed");
                return res.json();
            })
            .then(() => {
                // Redirect to cart page
                window.location.href = "/cart";
            })
            .catch(err => {
                console.error(err);
                if (addToCartBtn) {
                    addToCartBtn.innerText = "ERROR - TRY AGAIN";
                    addToCartBtn.disabled = false;
                }
            });
        });

        // Buy It Now listener
        const buyNowBtn = body.querySelector("#vsQvBuyNow");
        buyNowBtn?.addEventListener("click", () => {
            const variant = getSelectedVariant();
            const quantity = parseInt(qtyInput.value) || 1;
            window.location.href = `/cart/${variant.id}:${quantity}`;
        });
    };
});
